// extracted by mini-css-extract-plugin
export default {"parent":"formPhone_parent__pGTN6","parentErrorInform":"formPhone_parentErrorInform__hzdBq"};